import React from 'react'
import {
  Collapse,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableHead,
  Box,
  Typography,
  Chip,
  Container,
} from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  table: {
    backgroundColor: '#C1C1C1',
  },
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
}))

export const StaffBenefitRedemption = (props) => {
  const { row, openShowRedeemedUser } = props
  const classes = useStyles()

  const getUserRedemptionLimit = (user) => {
    if (row.departments.length > 0) {
      return (
        row.departments?.find((each) => each?.department === user.department)?.redemptionPerUser ??
        0
      )
    } else {
      return row?.redemptionPerUser
    }
  }

  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={openShowRedeemedUser} timeout='auto' unmountOnExit>
            <Container id='thisRow' maxWidth='md'>
              <Box margin={4}>
                <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                  Users that have redeemed:
                </Typography>
                <Box margin={1} border={1}>
                  <Table size='small' aria-label='purchases'>
                    <TableHead className={classes.table}>
                      <TableRow>
                        <TableCell align='right'>Employee Id</TableCell>
                        <TableCell align='right'>Name</TableCell>
                        <TableCell align='right'>Redeemed</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.redeemed?.map((user, idx) => (
                        <TableRow key={idx}>
                          <TableCell align='right'>{user.employeeId}</TableCell>
                          <TableCell align='right'>{user.name}</TableCell>
                          <TableCell align='right'>
                            {user.count}/{getUserRedemptionLimit(user)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Container>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}
